// extracted by mini-css-extract-plugin
export var hideEditor = "_is-2";
export var infoIcon = "_is-3";
export var label = "_is-1";
export var labelContainer = "_is-0";
export var readonlyText = "_is-4";